/* eslint-disable react/prop-types */
import axios from "axios";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { UrlApi } from "../../../services/apirest";

// 1. Crear el contexto
const PlantaContext = createContext();

// 2. Crear el proveedor
// eslint-disable-next-line
const STORAGE_KEY = "mp_planta_seleccionada";

export const PlantaProvider = ({ children }) => {
  const [plantaSeleccionada, setPlantaSeleccionadaState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? parseInt(saved, 10) : null;
  });
  const [plantas, setPlantas] = useState([]);

  const setPlantaSeleccionada = (id) => {
    if (id === null || id === undefined) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, id);
    }
    setPlantaSeleccionadaState(id);
  };
  const getPlantas = useCallback(async () => {
    await axios
      .get(UrlApi + "/mp_equipos/plantas")
      .then((res) => {
        const suc_auth = localStorage.getItem("suc_auth");
        if (!suc_auth) {
          console.log("No hay suc_auth en localStorage");
          return;
        }

        const storedIdsNumbers = suc_auth
          .split(",")
          .map((id) => parseInt(id.trim(), 10));

        const filteredData = res.data.filter(
          (item) => storedIdsNumbers.includes(parseInt(item.id_planta, 10)) // Aseguramos que id_planta sea un número
        );

        setPlantas(filteredData);

        // Si la planta guardada ya no está en la lista autorizada, la limpiamos
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved && !filteredData.some((p) => p.id_planta === parseInt(saved, 10))) {
          localStorage.removeItem(STORAGE_KEY);
          setPlantaSeleccionadaState(null);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    getPlantas();
  }, [getPlantas]);
  return (
    <PlantaContext.Provider
      value={{ plantas, plantaSeleccionada, setPlantaSeleccionada }}
    >
      {children}
    </PlantaContext.Provider>
  );
};

// 3. Hook personalizado para consumir el contexto
// eslint-disable-next-line
export const usePlanta = () => useContext(PlantaContext);
